__webpack_public_path__ = `${(window.resourceBaseUrl).replace('dist/', '')}`;
